import templateUrl from './signature-pad.component.html';
//import SignaturePad from 'signature_pad';

//export class SignaturePadController {
//    'ngInject'

//    boundingBox = {
//        width: 700,
//        height: 300,
//    };

//    constructor($scope) {
//        'ngInject'
//        console.log($scope);
//    }

//    $onInit = function () {

//    }
//}


export const SignaturePadComponent = {
    templateUrl,
    controller: SignaturePadController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


function SignaturePadController($scope) {
    'ngInject';
    const vm = this;
    vm.submit = submit;
    vm.boundingBox = {
        width: 700,
        height: 300,
    };

    function submit() {
        var x = $scope.accept();
        vm.close({ $value: x.dataUrl });
    }

    vm.$onInit = function () {
        console.log(vm.resolve);
    }
}

export const SignaturePadModal = {
    component: "apexSignaturePadModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
};
